import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicCheckbox, Loader } from 'core/components';
import _ from 'lodash';

const ChannelExcludedCarrierServicesTemplate = ({
	t,
	viewStore: {
		loading,
		modalParams,
		carrierServiceGroups,
		hasNoRequiredCarriers,
		isShipStationChannel,
		onCheck,
		onGroupSelectAllCheck,
		onSelectAllCheck,
		isGroupSelectAllChecked,
		isSelectAllChecked,
		allowedCount,
		excludedCount,
		submit,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{t('EXCLUDEDCARRIERSERVICES.TITLE')}</h3>
			</div>
			<div className="ReactModal__body">
				<div className="message message--tny message--primary spc--bottom--med">
					{t(
						hasNoRequiredCarriers
							? 'EXCLUDEDCARRIERSERVICES.NOREQUIREDCARRIERS'
							: isShipStationChannel
							? 'EXCLUDEDCARRIERSERVICES.SHIPSTATIONHINT'
							: 'EXCLUDEDCARRIERSERVICES.HINT'
					)}
				</div>

				{!hasNoRequiredCarriers && (
					<React.Fragment>
						<div className="card card--med spc--bottom--sml">
							<div className="spc--bottom--sml">
								<BaasicCheckbox
									checked={isSelectAllChecked}
									onChangeCallback={onSelectAllCheck}
									id={'excluded-carrier-services-select-all'}
									className={'input--check'}
									label={t('EXCLUDEDCARRIERSERVICES.ALLOWALL')}
								/>
							</div>

							<div className="separator--primary spc--bottom--sml"></div>

							<p className="type--xsml type--color--note">
								{t('EXCLUDEDCARRIERSERVICES.SUMMARY', { allowed: allowedCount, excluded: excludedCount })}
							</p>
							{allowedCount === 0 && (
								<p className="type--tny type--color--error">{t('EXCLUDEDCARRIERSERVICES.NONEALLOWED')}</p>
							)}
						</div>

						<div className="excluded-carrier-services__groups">
							{_.map(carrierServiceGroups, group => {
								return (
									<div className="excluded-carrier-services__group" key={group.carrierTypeName}>
										<div className="card card--med">
											<div className="spc--bottom--sml">
												<BaasicCheckbox
													checked={isGroupSelectAllChecked(group)}
													onChangeCallback={() => onGroupSelectAllCheck(group)}
													id={`excluded-carrier-services-group-${group.carrierTypeSlug}`}
													className={'input--check'}
													label={group.carrierTypeName}
												/>
											</div>

											<div className="separator--primary spc--bottom--sml"></div>

											{_.map(group.items, item => {
												return (
													<div className="spc--bottom--tny" key={item.id}>
														<BaasicCheckbox
															checked={item.isChecked}
															onChangeCallback={() => onCheck(item)}
															id={item.id}
															className={'input--check'}
															label={item.name}
														/>
													</div>
												);
											})}
										</div>
									</div>
								);
							})}
						</div>
					</React.Fragment>
				)}
			</div>
			<div className="ReactModal__footer">
				<button
					className="btn btn--med btn--primary spc--right--tny spc--bottom--sml"
					type="button"
					disabled={allowedCount === 0}
					onClick={submit}
				>
					{t('APPLY')}
				</button>
				<button
					className="btn btn--med btn--outline spc--bottom--sml"
					type="button"
					onClick={() => modalParams.close()}
				>
					{t('CANCEL')}
				</button>
			</div>
		</section>
	);
};

export default defaultTemplate(ChannelExcludedCarrierServicesTemplate);
